"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../../mantine-theme/src");
exports.default = react_jss_1.createUseStyles({
    grid: function (_a) {
        var theme = _a.theme, gutter = _a.gutter, cardsPerRow = _a.cardsPerRow, grow = _a.grow;
        var gutterSize = theme_1.getSizeValue({ size: gutter, sizes: theme.spacing });
        var getCardFlex = function (perRow) {
            return (grow ? 1 : 0) + " 0 calc(" + 100 / perRow + "% - " + gutterSize + "px)";
        };
        return {
            display: 'flex',
            flexWrap: 'wrap',
            margin: -gutterSize / 2,
            '& [data-mantine-card]': {
                margin: gutterSize / 2,
                flex: getCardFlex(cardsPerRow),
            },
        };
    },
}, { link: true });
